import { onlyNumbers } from './format';

// Link wa.me com a mensagem pronta; número sem DDI recebe o 55 do Brasil
export const linkWhatsapp = (telefone: string, mensagem: string): string => {
  let numero = onlyNumbers(telefone).replace(/^0+/, '');
  if (numero.length <= 11) {
    numero = '55' + numero;
  }
  return `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
};

type DadosRenovacao = {
  segurado: string;
  corretor: string;
  corretora?: string;
  tipo?: string;
  placa?: string;
  vigenciaFinal: string; // yyyy-mm-dd
  hoje?: string;         // yyyy-mm-dd, padrão = hoje
};

const primeiroNome = (nome: string) => nome.trim().split(/\s+/)[0];

const hojeIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const mensagemRenovacao = ({ segurado, corretor, corretora, tipo, placa, vigenciaFinal, hoje = hojeIso() }: DadosRenovacao): string => {
  const [ano, mes, dia] = vigenciaFinal.split('-');
  const vence = vigenciaFinal < hoje ? 'venceu em' : 'vence em';
  return `Olá, ${primeiroNome(segurado)}! Aqui é ${primeiroNome(corretor)}${corretora ? `, da ${corretora}` : ''}. `
    + `O seu seguro${tipo ? ` ${tipo.toLowerCase()}` : ''}${placa ? ` do veículo placa ${placa}` : ''} ${vence} ${dia}/${mes}/${ano}. `
    + 'Vamos cuidar da renovação?';
};
